/**
 * Navigation Shared Styles
 *
 * @module shared/components/navigation/styles
 *
 * Shared styles for navigation components
 */

import { alpha, type Theme, type SxProps } from '@mui/material/styles';

/**
 * Scrollable container styles for navigation sections
 */
export const scrollableStyles: SxProps<Theme> = {
  overflowY: 'auto',
  overflowX: 'hidden',
  '&::-webkit-scrollbar': {
    width: 6,
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    background: (theme: Theme) => theme.palette.divider,
    borderRadius: 3,
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: (theme: Theme) => alpha(theme.palette.text.primary, 0.2),
  },
};

/**
 * Scrollable container: small scrollbar, hidden by default, visible only while scrolling.
 * Use with scroll detection in the component (merge in thumb visibility when scrolling).
 */
export const scrollableStylesScrollOnly: SxProps<Theme> = {
  overflowY: 'auto',
  overflowX: 'hidden',
  '&::-webkit-scrollbar': {
    width: 4,
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    background: 'transparent',
    borderRadius: 2,
    transition: 'background 0.2s ease',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: (theme: Theme) => alpha(theme.palette.text.primary, 0.2),
  },
  scrollbarWidth: 'thin',
  scrollbarColor: 'transparent transparent',
};

